import { EVIDENCE_POLICY_SLOTS, EvidencePolicySlot, Storefront } from '../types/evidence';

// What the storefront and onboarding forms refuse before sending, worded as the field's error.

export const DOMAIN_MESSAGE = 'Enter a domain like example.com';
export const URL_MESSAGE = 'Enter a full address starting with http:// or https://';
export const EMAIL_MESSAGE = 'Enter a valid email address';

const DOMAIN = /^(https?:\/\/)?([\p{L}\p{N}]([\p{L}\p{M}\p{N}-]*[\p{L}\p{M}\p{N}])?\.)+(\p{L}[\p{L}\p{M}]+|xn--[a-z0-9-]+)(:\d+)?([/?#]\S*)?$/iu;
// zod's z.email() pattern, so the form agrees with what the API accepts.
const EMAIL = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/;

// A domain is required wherever it is offered; a URL and a support email are optional until typed.
export function domainMessage(value: string): string | null {
  return DOMAIN.test(value.trim()) ? null : DOMAIN_MESSAGE;
}

export function urlMessage(value: string): string | null {
  const url = value.trim();
  if (!url) return null;
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:' ? null : URL_MESSAGE;
  } catch {
    return URL_MESSAGE;
  }
}

export function emailMessage(value: string): string | null {
  const email = value.trim();
  if (!email) return null;
  return EMAIL.test(email) ? null : EMAIL_MESSAGE;
}

// Mirrors requiredPolicySlots in apps/api/utils/evidencePolicy.ts.
export function requiredPolicySlots(storefront: Pick<Storefront, 'digital'>): EvidencePolicySlot[] {
  return EVIDENCE_POLICY_SLOTS.filter((slot) => !(storefront.digital && slot === 'shipping'));
}
